import { trace, setCookie } from 'rytm-helpers'
import Controller from './Controller'

class CategoryMenuController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.setListingCookie()
  }
  addEventListeners() {
    super.addEventListeners()
  }
  removeEventListeners() {
    super.removeEventListeners()
  }
  /**
   * ###########
   * ### OWN ###
   */
  setListingCookie() {
    const container = document.querySelector(this.getContainerSelector())
    const listingId = container ? container.dataset.listingId : null
    if (listingId) {
      setCookie("cdz_listing_id", listingId)
    }
  }
  
}

export default CategoryMenuController;